// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const Dialog = (el) => {
  const ui = {
    el,
    body: select('body', document),
    show: select('.dialog-show', document),
    close: select('.dialog__close', el),
    confirm: select('.dialog__confirm', el),
    cancel: select('.dialog__cancel', el),
    video: select('.video', el),
    iframe: select('iframe', el),
  };
  
  const pauseVideoEmbed = () => {
    if (ui.iframe) {
      let iframeSrc = ui.iframe.src;
      ui.iframe.src = iframeSrc;
    } else if (ui.video) {
      ui.video.pause();
    }
  }

  const openDialog = () => {
    ui.el.showModal();
  };

  const closeDialog = () => {
    pauseVideoEmbed();
    ui.el.close();
  }

  const confirmation = () => {
    console.log('confirmation clicked');
  }

  const cancellation = () => {
    console.log('cancellation clicked');
  }

  const addEvents = () => {
    ui.show.addEventListener('click', () => {
      openDialog();
    });
    ui.close.addEventListener('click', () => {
      closeDialog();
    });
    if (ui.confirm) {
      ui.confirm.addEventListener('click', () => {
        confirmation();
      });
    }
    if (ui.cancel) {
      ui.cancel.addEventListener('click', () => {
        cancellation();
      });
    }
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default Dialog;
